import { render, staticRenderFns } from "./OperationAndTellerStaffSelect.vue?vue&type=template&id=06210ded"
import script from "./OperationAndTellerStaffSelect.vue?vue&type=script&lang=js"
export * from "./OperationAndTellerStaffSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/projects/teller/components/OperationAndTellerStaffSelect.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_OPERATION%2Fsrc%2Fprojects%2Fteller%2Fcomponents%2FOperationAndTellerStaffSelect.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports